import React from "react";
import PropTypes from "prop-types";

import styles from "./style.css";

export function Slider(props) {
  const { value = 0, column } = props;
  const { min = 0, max = 100 } = column;
  const perc = ((value - min) / (max - min)) * 100;
  const style = {
    backgroundSize: `calc(${
      window.isRTL ? 100 - perc : perc
    }%) 4px, calc(100%) 4px`
  };
  return (
    <div
      className={styles.slider}
      data-min={min}
      data-max={max}
      style={style}
    />
  );
}

Slider.propTypes = {
  value: PropTypes.number,
  column: PropTypes.any
};
